define.alias("shared/components/shared/ui/mobile-redirect-prompt", "calendar/components/shared/ui/mobile-redirect-prompt");